import { Injectable, signal, computed } from '@angular/core';
import {
  DonutChartDataItem,
  GenderTypeData,
  AgeChartItem,
} from 'src/app/models/core/chart-interfaces';
import {
  EMPTY_DEMOGRAPHICS,
  mapDemographics,
  toGenderTableRows,
} from 'src/app/utils/reports/demographics.mapper';
import { GlobalReportApiService } from './global-report-api.service';
import { HeaderKpisService } from './header-kpis.service';
import { latestRequestTracker } from 'src/app/utils/reports/latest-request';
import { NGXLogger } from 'ngx-logger';

export interface ClientListItem {
  id: number;
  name: string;
  email: string;
  gender?: string;
  verified: boolean;
  ticket_code?: string;
  product_name?: string;
}

@Injectable({ providedIn: 'root' })
export class ClientReportService {
  // ─── Demográficos ───
  readonly demographicsLoading = signal(false);
  readonly genderChartItems = signal<DonutChartDataItem[]>([]);
  readonly ageChartItems = signal<AgeChartItem[]>([]);

  readonly genderTableData = computed<GenderTypeData[]>(() => toGenderTableRows(this.genderChartItems()));


  private readonly demographicsRequest = latestRequestTracker();

  constructor(
    private globalReportApi: GlobalReportApiService,
    private headerKpisService: HeaderKpisService,
    private logger: NGXLogger,
  ) {}

  /** Género y edad del evento actual, para la pestaña Clientes. */
  loadDemographics(): void {
    const eventId = this.headerKpisService.eventId;
    if (!eventId) return;

    this.demographicsLoading.set(true);
    const isLatest = this.demographicsRequest.start();

    this.globalReportApi.getDemographics(eventId).subscribe({
      next: (res) => {
        if (!isLatest()) return;
        const { gender, age } = mapDemographics(res);
        this.genderChartItems.set(gender);
        this.ageChartItems.set(age);
      },
      error: (error: unknown) => {
        if (!isLatest()) return;
        this.logger.error('Error cargando la demografía (Jefe/Admin)', { eventId, error });
        this.genderChartItems.set(EMPTY_DEMOGRAPHICS.gender);
        this.ageChartItems.set(EMPTY_DEMOGRAPHICS.age);
        this.demographicsLoading.set(false);
      },
      complete: () => {
        if (isLatest()) this.demographicsLoading.set(false);
      },
    });
  }

  // ─── Reset ───

  resetAllState(): void {
    this.genderChartItems.set([]);
    this.ageChartItems.set([]);
    this.demographicsLoading.set(false);
  }
}
